import React, { FC } from 'react';
import { FormContainer } from '@ui/components/atoms';
import CheckIcon from '@assets/svg/check-solid.svg';
import { useTranslate } from '@translations/useTranslate';
import SuccessMessageStyles from './SuccessMessage.module.scss';

export const SuccessMessage: FC<{ isOwn: boolean; ticketNumber?: string }> = ({
  ticketNumber,
  isOwn,
}) => {
  const { t } = useTranslate();
  return (
    <FormContainer>
      <div className="w-100 d-flex justify-content-center align-items-center flex-column gap-2 pb-5">
        <span className={SuccessMessageStyles.success_message__icon}>
          <img src={CheckIcon} alt="Check icon" />
        </span>
        <p className={SuccessMessageStyles.success_message__message}>
          {t('successMessage.ibs.title')}
        </p>
        {ticketNumber && (
          <p className={SuccessMessageStyles.success_message__ticket}>
            {t('successMessage.ticket')} <span>{ticketNumber}</span>
          </p>
        )}

        {!isOwn && (
          <p className={SuccessMessageStyles.success_message__hint} dir="auto">
            {t('successMessage.info1')}
            <a href="mailto:dgo@tawal.com.sa">dgo@tawal.com.sa</a>
            <br />
            {t('successMessage.info2')}
          </p>
        )}
      </div>
    </FormContainer>
  );
};
